import * as actionTypes from './actionTypes';
import loginService from 'services/loginService';
import userService from 'services/userService';
import landingService from 'services/landingService';
import voucherService from 'services/voucherService';
import objectUtils from 'utils/object';
import googleAnalyticsUtils from 'utils/googleAnalytics';
import inspectletUtils from 'utils/inspectlet';
import queryString from 'utils/queryString';

export const toggleRegisterCompany = toggle => {
  return {
    type: actionTypes.TOGGLE_REGISTER_COMPANY,
    toggle: toggle,
  };
};

const loggingIn = () => {
  return {
    type: actionTypes.USER_LOGGING_IN,
  };
};

function loggingOut() {
  return {
    type: actionTypes.USER_LOGGING_OUT,
  };
}

export const sendEmailToRegisterCompany = payload => {
  return dispatch => {
    landingService
      .sendEmailToRegisterCompany(payload)
      .then(data => {
        dispatch(successSendEmailToRegisterCompany());
      })
      .catch(err => {
        console.log(err);
      });
  };
};

const successSendEmailToRegisterCompany = () => {
  return {
    type: actionTypes.SUCCESS_SEND_EMAIL_REGISTER_COMPANY,
  };
};

export const sendEmailContact = payload => {
  return dispatch => {
    dispatch(toggleSendEmailContact(false));
    landingService
      .sendEmailContact(payload)
      .then(data => {
        dispatch(toggleSendEmailContact(true));
      })
      .catch(err => {
        console.log(err);
      });
  };
};

const toggleSendEmailContact = toggle => {
  return {
    type: actionTypes.TOGGLE_SEND_EMAIL_CONTANT,
    toggle: toggle,
  };
};

export const requestVerifyEmail = credentials => {
  return dispatch => {
    loginService
      .preLogin(credentials)
      .then(data => {
        if (
          !!data.hasRelatedBusiness &&
          !data.userAlreadyRegistered &&
          !data.retailOnly
        ) {
          dispatch(startSignup(credentials.email));
        } else if (!data.hasRelatedBusiness) {
          dispatch(
            requestFailed({
              message:
                "Hey looks like we don't have your office set up. Chat to a member of our team in Live Chat and sign up in seconds!",
            })
          );
        } else if (data.retailOnly) {
          dispatch(
            requestFailed({
              message: 'User is not registred in LunchTeam.',
            })
          );
        } else if (data.userAlreadyRegistered) {
          dispatch(preLogin(credentials.email));
        }
      })
      .catch(error => {
        if (!!error.errors) {
          const errorMessage =
            error.message + `${error.errors[0].field} is invalid`;
          dispatch(requestFailed({ message: errorMessage }));
        } else {
          dispatch(requestFailed({ message: error.message }));
        }
      });
  };
};

export const requestLogin = credentials => {
  return dispatch => {
    const params = queryString.parse(window.location.search);
    loginService
      .login(credentials)
      .then(userDetails => {
        if (process.env.NODE_ENV === 'development') {
          localStorage.setItem(
            '@LT/DEV_KEYS',
            window.btoa(`${credentials.email}:${credentials.password}`)
          );
        }
        googleAnalyticsUtils.sendWhoIsAccessing(userDetails.username);
        dispatch(requestSuccessLogin(userDetails));
        inspectletUtils.tagSession(userDetails);
        dispatch(createLinkVoucher(params));
        localStorage.setItem('country', userDetails.country);
      })
      .catch(err => {
        if (err.response.status === 401) {
          dispatch(requestFailed({ message: 'Invalid credentials' }));
        } else {
          dispatch(
            requestFailed({
              message:
                'We get some error from our services, please contact the support',
            })
          );
        }
      });
  };
};

export const requestEmailResetPassword = email => {
  return dispatch => {
    userService
      .requestEmailResetPassword({ email: email })
      .then(data => {
        dispatch(requestSentEmailResetPasswordSuccess());
      })
      .catch(err => {
        console.log(err);
      });
  };
};

const requestSentEmailResetPasswordSuccess = email => {
  return {
    type: actionTypes.REQUEST_SENT_EMAIL_RESET_PASSWORD_SUCCESS,
  };
};

export function tryAutomaticallyLogin() {
  return async dispatch => {
    const params = queryString.parse(window.location.search);
    dispatch(loggingIn());

    try {
      const response = await loginService.login();
      if (!!objectUtils.get(response, 'idUser', undefined)) {
        dispatch(requestSuccessLogin(response));
        inspectletUtils.tagSession(response);
        dispatch(createLinkVoucher(params));
      } else {
        dispatch(loggingOut());
      }
    } catch (error) {
      dispatch(loggingOut());
    }
  };
}

const startSignup = email => {
  return {
    type: actionTypes.START_SIGNUP,
    email: email,
  };
};

const requestFailed = errorMessage => {
  return {
    type: actionTypes.REQUEST_FAILED,
    errorMessage: errorMessage.message,
  };
};

const preLogin = email => {
  return {
    type: actionTypes.PRE_LOGIN,
    email: email,
  };
};

const requestSuccessLogin = userDetails => {
  return {
    type: actionTypes.REQUEST_SUCCESS_LOGIN,
    userDetails: userDetails,
  };
};

export const closeModalError = () => {
  return {
    type: actionTypes.CLOSE_MODAL_ERROR,
  };
};

export const openModalError = messageError => {
  return {
    type: actionTypes.CHECKOUT_REALEX_TOGGLE_SHOW_MODAL_ERROR,
    payload: { show: true, messageError: messageError },
  };
};

export const createLinkVoucher = params => {
  return async dispatch => {
    if (params.isCodeLink) {
      try {
        voucherService
          .createLinkVoucher(params.code)
          .then(data => {
            dispatch(
              requestSuccessCreateVoucher({ message: `You've got a voucher!` })
            );
          })
          .catch(err => {
            dispatch(
              requestFailedCreateVoucher({
                message: `Voucher is not available anymore.`,
              })
            );
          });
      } catch (error) {
        dispatch(
          requestFailedCreateVoucher({
            message: `Voucher is not available anymore.`,
          })
        );
      }
    }
  };
};

const requestSuccessCreateVoucher = successMessage => {
  return {
    type: actionTypes.REQUEST_SUCCESS_CREATE_VOUCHER,
    message: successMessage.message,
  };
};

const requestFailedCreateVoucher = errorMessage => {
  return {
    type: actionTypes.REQUEST_FAILED_CREATE_VOUCHER,
    message: errorMessage.message,
  };
};

export const closeSuccessModalCreateLinkVoucher = successMessage => {
  return {
    type: actionTypes.CLOSE_MODAL_SUCCESS_CREATE_LINK_VOUCHER,
  };
};

export const closeErrorModalCreateLinkVoucher = () => {
  return {
    type: actionTypes.CLOSE_MODAL_ERROR_CREATE_LINK_VOUCHER,
  };
};



// WEBPACK FOOTER //
// ./src/store/actions/Landing.js